
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import TitleSidebar from '@/components/details/TitleSidebar.vue';
import InfoBoxWrapper from '@/components/details/InfoBoxWrapper.vue';

import { SnowplowContext } from '@/helpers/tracking/providers/snowplow-contexts';

import { TitleDetailsNode } from '@/interfaces/title-details-graphql';
import { TitleContentType } from '@/interfaces/snowplow/title-context';
import type { SponsoredAdFragment } from '@/pages/graphql/fragments/SponsoredAd.fragment';

@Component({
	name: 'InfoBox',
	components: { TitleSidebar, InfoBoxWrapper },
})
export default class InfoBox extends Vue {
	// TODO [Graphql]: Substitute for required fields only, each field - new prop
	@Prop({ required: true }) title: TitleDetailsNode;
	@Prop({ default: () => [] }) additionalContexts: SnowplowContext[];
	@Prop({ default: false }) isBackdropTrailerPlaying: boolean;
	@Prop({ default: false }) hasBackdropContent: boolean;
	@Prop() titleContentType: TitleContentType | undefined;
	@Prop({ default: null }) influencedSponsoredAd: SponsoredAdFragment;
}
